export default "__VITE_ASSET__Ba8w6cRR__"